import React from "react";
import { Space } from "antd";
import SchedulingsUpload from "./SchedulingsUpload";

const Interfaces = () => {
  return (
    <Space
      size="small"
      direction="vertical"
      style={{ width: "100%", backgroundColor: "transparent" }}
    >
      <SchedulingsUpload />
    </Space>
  );
};

export default Interfaces;
